import React from 'react';

const QuestionsMap = ({ questions, onQuestionSelected }) => {
    return (
        <div className="questions-map">
            <div className="questions-map__lines">
                <div className="questions-map__line">
                {
                    questions && questions.map((question, index) => {
                        return(
                            <div
                                key={question._id}
                                className={`questions-map__question ${question.vista ? question.resposta ? 'done' : 'undone' : ''}`}
                                onClick={() => onQuestionSelected(index)}
                            >
                                { index + 1 }
                            </div>
                        )

                    })
                }
                </div>
            </div>
            <div className="questions-map__legend-question-page">
                <div className="legend-color" />
                <small>Questões não respondidas (clique para responder)</small>
            </div>
        </div>
    )
};

export { QuestionsMap }
